import cn from "clsx";
import Image from "next/image";
import React, {
  ButtonHTMLAttributes,
  forwardRef,
  JSXElementConstructor,
} from "react";
import Puce2 from "@static/images/icons/daily-btn-fleche.png";
import Puce from "@static/images/icons/puce-button.png";
import s from "./Button.module.scss";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  href?: string;
  className?: string;
  variant?: "primary" | "secondary" | "secondaryGreen" | "default";
  active?: boolean;
  type?: "submit" | "reset" | "button";
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Component?: string | JSXElementConstructor<any>;
  width?: string | number;
  loading?: boolean;
  disabled?: boolean;
  puce?: boolean;
  outline?: boolean;
}

export const Button: React.FC<ButtonProps> = forwardRef((props, buttonRef) => {
  const {
    className,
    variant = "primary",
    children,
    active,
    width,
    loading = false,
    disabled = false,
    outline = false,
    puce = true,
    style = {},
    Component = "button",
    ...rest
  } = props;
  const classes = className?.split(" ").reduce(
    (acc, cls) => ({
      ...acc,
      [s[cls]]: true,
    }),
    {}
  );
  const rootClassName = cn(
    s.root,
    {
      [s.default]: variant === "default",
      [s.secondary]: variant === "secondary",
      [s.secondaryGreen]: variant === "secondaryGreen",
      [s.loading]: loading,
      [s.disabled]: disabled,
      [s.outline]: outline,
    },
    className,
    classes
  );

  return (
    <Component
      aria-pressed={active}
      data-variant={variant}
      ref={buttonRef}
      className={rootClassName}
      disabled={disabled}
      style={{
        width,
        ...style,
      }}
      {...rest}
    >
      <>
        {children}
        {puce && variant !== "secondaryGreen" && (
          <Image src={Puce} width="20" height="21" alt="" />
        )}
        {puce && variant === "secondaryGreen" && (
          <Image src={Puce2} width="20" height="21" alt="" />
        )}
      </>
    </Component>
  );
});

export default Button;
